import type { ExportedResourcesResponse } from '../../types';
import { logger } from '../../utils/logger';
import { authenticatedFetch } from '../../utils/authenticatedFetch';
import { getV2AuthHeaders } from '../../utils/authHeaders';
import { getEnv } from '../../config/env';

// ========================================
// TODO: DELETE - Demo migration mock data
// ========================================
// Mock migration ID for the demo
const DEMO_MIGRATION_ID = 'd08d06c5-5e7e-470d-b2ed-314e9bf6d79e';

// Mock exported resources for the demo migration
const MOCK_EXPORTED_RESOURCES: ExportedResourcesResponse = {
  migrationId: DEMO_MIGRATION_ID,
  stage: 'ExportComplete',
  resourceTypes: {
    genesyscloud_auth_role: [
      'Agent_Assist_Omni_Agent_Steve',
      'Manual_Agent_Assist',
      'Master_Admin',
      'admin',
      'agentic',
      'CX_as_Code_Automation_TEST',
      'Knowledge2',
      'Test_Token_Consumption'
    ],
    genesyscloud_group: ['Campaign_Manager_Users', 'EDCi_RepliCloud', 'WEC_OLE_Testers'],
    genesyscloud_user: ['scott_schroth', 'steve_alix']
  },
  totalTypes: 3,
  totalResources: 13
};

export const fetchExportedResourcesFromService = async (
  bearerToken: string,
  migrationId: string
): Promise<ExportedResourcesResponse> => {
  // Return mock data for the demo migration
  if (migrationId === DEMO_MIGRATION_ID) {
    return Promise.resolve(MOCK_EXPORTED_RESOURCES);
  }

  try {
    const baseUrl = getEnv().VITE_EDCI_API_URL;
    const url = `${baseUrl}/api/migrations/${migrationId}/exportedResources`;

    const response = await authenticatedFetch(url, {
      headers: getV2AuthHeaders(bearerToken)
    });

    if (!response.ok) {
      logger.error('Fetch exported resources API returned error', {
        status: response.status,
        statusText: response.statusText,
        migrationId,
        url
      });
      throw new Error(
        `Error fetching exported resources: ${response.status} ${response.statusText}`
      );
    }

    const data: ExportedResourcesResponse = await response.json();
    logger.info('Exported resources fetched successfully', {
      migrationId,
      stage: data.stage,
      totalTypes: data.totalTypes,
      totalResources: data.totalResources
    });
    return data;
  } catch (error) {
    const msg = error instanceof Error ? error.message : String(error);
    logger.error('Failed to fetch exported resources', {
      error: msg,
      migrationId,
      url: `${getEnv().VITE_EDCI_API_URL}/api/migrations/${migrationId}/exportedResources`
    });
    throw error;
  }
};

export default fetchExportedResourcesFromService;
